"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseDataServerClient = void 0;

var _lodash = require("lodash");

var _xml2js = require("xml2js");

var _async = require("../../utils/async");

var _genericAsResultHeader = require("../../utils/generic-as-result-header");

var _BaseDataService2 = require("../../core/BaseDataService");

var _consts = require("../../core/consts");

var _consts2 = require("./consts");

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var xmlParser = new _xml2js.Parser();
var xmlBuilder = new _xml2js.Builder({
  emptyTag: ' ',
  renderOpts: {
    'pretty': true,
    'indent': '\t',
    'newline': '\n',
    allowEmpty: true
  }
});
/**
 * Defines a base class for talking to DataServer SOAP(ish) endpoints. Exposes a "protected" _send method
 * that children should use to execute requests.
 */

var BaseDataServerClient =
/*#__PURE__*/
function (_BaseDataService) {
  _inherits(BaseDataServerClient, _BaseDataService);

  function BaseDataServerClient(httpProvider) {
    var _this;

    var baseUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _consts.DEFAULT_DATA_SERVER_PATH;
    var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _consts2.SOAP_ACTION_IMAGE_MANAGEMENT;

    _classCallCheck(this, BaseDataServerClient);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BaseDataServerClient).call(this));
    Object.assign(_assertThisInitialized(_assertThisInitialized(_this)), {
      get _httpProvider() {
        return httpProvider;
      },

      get _baseUrl() {
        return baseUrl;
      },

      get _apiPath() {
        return path;
      }

    });
    return _this;
  }

  _createClass(BaseDataServerClient, [{
    key: "_send",
    value: function () {
      var _send2 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(_ref) {
        var methodName, _ref$data, data, _ref$xmlProcessor, xmlProcessor, _ref$parseResponseDel, parseResponseDelegate, _ref$apiUrl, apiUrl, xml, response, json, reply;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                methodName = _ref.methodName, _ref$data = _ref.data, data = _ref$data === void 0 ? {} : _ref$data, _ref$xmlProcessor = _ref.xmlProcessor, xmlProcessor = _ref$xmlProcessor === void 0 ? null : _ref$xmlProcessor, _ref$parseResponseDel = _ref.parseResponseDelegate, parseResponseDelegate = _ref$parseResponseDel === void 0 ? _genericAsResultHeader.createGenericResult : _ref$parseResponseDel, _ref$apiUrl = _ref.apiUrl, apiUrl = _ref$apiUrl === void 0 ? null : _ref$apiUrl;
                data['$'] = {
                  'xmlns': 'http://www.aperio.com/webservices/'
                };
                xml = xmlBuilder.buildObject({
                  'soap:Envelope': {
                    '$': {
                      'xmlns:xsi': 'http://www.w3.org/2001/XMLSchema-instance',
                      'xmlns:xsd': 'http://www.w3.org/2001/XMLSchema',
                      'xmlns:soap': 'http://schemas.xmlsoap.org/soap/envelope/'
                    },
                    'soap:Body': _defineProperty({}, methodName, data)
                  }
                });

                if (xmlProcessor) {
                  xml = xmlProcessor(xml);
                }

                apiUrl = apiUrl || this._apiPath;
                _context.next = 7;
                return trySendRequest(this._httpProvider, this._baseUrl, apiUrl, methodName, xml);

              case 7:
                response = _context.sent;
                _context.next = 10;
                return (0, _async.asAsync)(xmlParser.parseString, response.data);

              case 10:
                json = _context.sent;
                json = (0, _lodash.get)(json, "soap:Envelope.soap:Body[0].".concat(methodName, "Response[0]"));

                if (!parseResponseDelegate) {
                  _context.next = 17;
                  break;
                }

                reply = parseResponseDelegate(json, methodName);

                if (!(reply.result.asResult !== 0)) {
                  _context.next = 16;
                  break;
                }

                throw reply.result;

              case 16:
                if (reply.hasOwnProperty('totalRecordCount') || reply.hasOwnProperty('returnedCount')) {
                  delete reply.asResult; // already handled.

                  json = reply;
                } else {
                  // trim a level non-list replies
                  json = reply.response;
                }

              case 17:
                response.data = json;
                return _context.abrupt("return", response);

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function _send(_x) {
        return _send2.apply(this, arguments);
      };
    }()
  }]);

  return BaseDataServerClient;
}(_BaseDataService2.BaseDataService); // DataServer isn't the most reliable service. One of the more common problems is that it occasionally "deadlocks". The
// response says to "try the request again", so let's just do that globally here and hopefully make the API appear more
// reliable.


exports.BaseDataServerClient = BaseDataServerClient;
var DEADLOCK_RESULT = '<ASResult>-7014</ASResult>';
var DEADLOCK_RETRY_DELAY = 250;
var MAX_ALLOWED_SEQUENTIAL_DEADLOCK_ERRORS = 5;
var deadlockCounter = 0;

function trySendRequest(_x2, _x3, _x4, _x5, _x6) {
  return _trySendRequest.apply(this, arguments);
}

function _trySendRequest() {
  _trySendRequest = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(http, baseUrl, apiUrl, methodName, xml) {
    var response;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return http.request({
              method: 'POST',
              baseURL: baseUrl,
              url: apiUrl,
              headers: {
                'Content-type': 'application/xml; charset=UTF-8',
                SOAPAction: "http://www.aperio.com/webservices/".concat(methodName)
              },
              data: xml
            });

          case 2:
            response = _context2.sent;

            if (!response.data.includes(DEADLOCK_RESULT)) {
              _context2.next = 15;
              break;
            }

            console.warn('DATASERVER IS DEADLOCKED!', methodName, xml);
            deadlockCounter++;

            if (!(deadlockCounter > MAX_ALLOWED_SEQUENTIAL_DEADLOCK_ERRORS)) {
              _context2.next = 8;
              break;
            }

            throw new Error('DATA_SERVER_DEADLOCKED');

          case 8:
            _context2.next = 10;
            return (0, _async.wait)(DEADLOCK_RETRY_DELAY);

          case 10:
            _context2.next = 12;
            return trySendRequest(http, baseUrl, apiUrl, methodName, xml);

          case 12:
            response = _context2.sent;
            _context2.next = 16;
            break;

          case 15:
            deadlockCounter = 0;

          case 16:
            return _context2.abrupt("return", response);

          case 17:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));
  return _trySendRequest.apply(this, arguments);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/data-server/core/BaseDataServerClient.js
// module id = 57
// module chunks = 0